// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"9b65475f","431":"041defe4","858":"ec13c0da"}[chunkId] + ".js";
};